import { buildModelManager } from "../builder.js";
const DefaultCustomCouponCodeSelection = {
  __typename: true,
  id: true,
  category: true,
  code: true,
  contactId: true,
  createdAt: true,
  customerId: true,
  expiredAt: true,
  status: true,
  updatedAt: true,
  usedAt: true
};
const modelApiIdentifier = "customCouponCode";
const pluralModelApiIdentifier = "customCouponCodes";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCustomCouponCodeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCustomCouponCodeSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByCode",
    findByField: "code",
    findByVariableName: "code",
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByCode",
    findByField: "code",
    findByVariableName: "code",
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createCustomCouponCode",
    operationReturnType: "CreateCustomCouponCode",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      customCouponCode: { required: false, type: "CreateCustomCouponCodeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomCouponCodeSelection
  },
  {
    type: "action",
    operationName: "bulkCreateCustomCouponCodes",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateCustomCouponCodesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCustomCouponCodeSelection
  },
  {
    type: "action",
    operationName: "updateCustomCouponCode",
    operationReturnType: "UpdateCustomCouponCode",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      customCouponCode: { required: false, type: "UpdateCustomCouponCodeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomCouponCodeSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateCustomCouponCodes",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateCustomCouponCodesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCustomCouponCodeSelection
  },
  {
    type: "action",
    operationName: "deleteCustomCouponCode",
    operationReturnType: "DeleteCustomCouponCode",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteCustomCouponCodes",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertCustomCouponCode",
    operationReturnType: "UpsertCustomCouponCode",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      customCouponCode: { required: false, type: "UpsertCustomCouponCodeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateCustomCouponCodeResult": { hasReturnType: false },
      "... on UpdateCustomCouponCodeResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomCouponCodeSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertCustomCouponCodes",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertCustomCouponCodesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultCustomCouponCodeSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "customCouponCodeGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const CustomCouponCodeManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultCustomCouponCodeSelection,
  operations
);
export {
  CustomCouponCodeManager,
  DefaultCustomCouponCodeSelection
};
//# sourceMappingURL=CustomCouponCode.js.map
